// window.addEventListener('load', function() {
//   // Increase label and image size within .quotes-swatch
//   document.querySelectorAll('.quotes-swatch .swatch-container .customily-swatch label').forEach(function(label) {
//     label.style.width = '100px';
//     label.style.minWidth = '100px';
//     label.style.maxWidth = '100px';
//     label.style.height = '100px';
//     label.style.minHeight = '100px';
//     label.style.maxHeight = '100px';
//     console.log(label)
//   });

//   document.querySelectorAll('.quotes-swatch .swatch-container .customily-swatch label img').forEach(function(img) {
//     img.style.width = '100%';
//     img.style.height = '100%';
//     img.style.width = '100%';
//     img.style.minWidth = '100%';
//     img.style.maxWidth = '100%';
//     img.style.height = '100%';
//     img.style.minHeight = '100%';
//     img.style.maxHeight = '100%';
//   });
// });


document.addEventListener('DOMContentLoaded', function () {
  const moreDescription = document.getElementById('moreDescription');
  const lessDescription = document.getElementById('lessDescription');

  const toggleButtons = document.querySelectorAll('.toggleDescrip');

  toggleButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      toggleDescriptions();
    });
  });

  function toggleDescriptions() {
    if (moreDescription.style.display === 'none') {
      moreDescription.style.display = 'block';
      lessDescription.style.display = 'none';
    } else {
      moreDescription.style.display = 'none';
      lessDescription.style.display = 'block';
    }
  }
  
});

// ========


(function () {
  const observer = new MutationObserver(function () {
    const button = document.querySelector(
      '.shopify-app-block .eu-withdrawal-link[data-eu-widget="1"]'
    );

    const lastColumn = document.querySelector('.footer__inner .footer__block-list > .footer__block:last-child');

    if (!button || !lastColumn) return;

    if (button.parentElement !== lastColumn) {
      lastColumn.appendChild(button);
    }

    observer.disconnect();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

